import React from 'react';
import { StudyGuideCard } from '../study-guide-card';
import flag from './img/flag.svg';
import trophy from './img/trophy.svg';
import relaxation from './img/relaxation.svg';
import { TIAResults } from '@/app/components/TIA';
import moment from 'moment';
import {
  GuideTimeline,
  GuideTimelineBody,
  GuideTimelineCards,
  GuideTimelineContent,
  GuideTimelineDate,
  GuideTimelineDay,
  GuideTimelineFooter,
  GuideTimelineHeader,
  GuideTimelineIcon,
  GuideTimelineImg,
  GuideTimelineText,
  GuideTimelineTitle
} from '@/components/custom/guide';

export function StudyGuideTimeline({ studyGuide }) {
  const daysOfWeek = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta'];

  const getMotivationalMessage = dayOfWeek => {
    switch (dayOfWeek) {
      case 'Segunda':
        return 'Vamos começar mais uma semana com todo o gás!';
      case 'Terça':
      case 'Quarta':
      case 'Quinta':
        return 'Continue! Seu esforço não é em vão.';
      case 'Sexta':
        return 'Falta pouco para concluir essa semana de estudos. Vamos lá!';
      default:
        return 'Vamos começar mais um dia com todo o gás';
    }
  };

  const tiaResultsDate = moment(studyGuide?.['daily-message']?.['created-at']).format('YYYY-MM-DD');
  const tiaResultsMessage = studyGuide?.['daily-message']?.body;

  const videosByDate = studyGuide['study-plan-videos'].reduce((acc, video) => {
    const formattedDate = moment(video.date).format('YYYY-MM-DD');
    if (!acc[formattedDate]) {
      acc[formattedDate] = [];
    }
    acc[formattedDate].push(video);
    return acc;
  }, {});

  const sortedDates = Object.keys(videosByDate).sort();
  let firstUndoneFound = false;

  return (
    <GuideTimeline>
      {sortedDates.map((date, index) => {
        const currentDate = moment(date).format('DD [de] MMMM [de] YYYY');
        const dayOfWeek = daysOfWeek[index % 5];
        const today = moment().format('YYYY-MM-DD');

        return (
          <GuideTimelineDay key={index}>
            <GuideTimelineHeader id={dayOfWeek.toLowerCase()}>
              <GuideTimelineIcon
                src={flag}
                alt="bandeira"
              />
              <GuideTimelineTitle>{getMotivationalMessage(dayOfWeek)}</GuideTimelineTitle>
              <GuideTimelineDate>{`${dayOfWeek}, ${currentDate}`}</GuideTimelineDate>
            </GuideTimelineHeader>

            <GuideTimelineCards>
              {tiaResultsDate === date && dayOfWeek !== 'Segunda' && (
                <>
                  {tiaResultsMessage && <TIAResults message={tiaResultsMessage} />}
                  <br />
                  <br />
                </>
              )}

              {videosByDate[date].map((video, idx) => {
                const nextToBeDone = !firstUndoneFound && video.done === false;
                if (nextToBeDone) {
                  firstUndoneFound = true;
                }
                return (
                  <StudyGuideCard
                    key={idx}
                    done={video.done}
                    title={video.taxonomy.name}
                    video={video}
                    guide_index={idx}
                    canBeClicked={date <= today}
                    isCurrent={nextToBeDone}
                  />
                );
              })}
            </GuideTimelineCards>

            <GuideTimelineFooter>
              <GuideTimelineIcon
                src={trophy}
                alt="troféu"
              />
              {index < 4 ? <GuideTimelineTitle>Chegamos ao final da {dayOfWeek.toLowerCase()}-feira.</GuideTimelineTitle> : <GuideTimelineTitle>Parabéns. Você finalizou mais uma semana</GuideTimelineTitle>}
            </GuideTimelineFooter>
          </GuideTimelineDay>
        );
      })}

      <GuideTimelineDay isPause>
        <GuideTimelineBody>
          <GuideTimelineContent>
            <GuideTimelineTitle>Oba, o final de semana chegou</GuideTimelineTitle>
            <GuideTimelineText>
              Aproveite para recarregar as energias.
              <br /> Nos vemos na próxima semana!
            </GuideTimelineText>
          </GuideTimelineContent>
          <GuideTimelineImg
            src={relaxation}
            alt="relaxamento"
          />
        </GuideTimelineBody>
      </GuideTimelineDay>
    </GuideTimeline>
  );
}
